import React, { useState } from 'react';
import { Container, Grid, useMantineTheme, Paper, Box } from '@mantine/core';
import { NewCarePlan } from '../CarePlan/NewCareplan';
import Layout from './Layout';
import { carePlanSections, referralSections } from './Constant';
import BorderFrame from './Border';
import Footer from './EmbedFooter';

const CarePlanEmbed: React.FC = () => {
  const theme = useMantineTheme();
  const [showBorder, setShowBorder] = useState<boolean>(false);

  const handleCheckboxChange = (isChecked: any) => {
    setShowBorder(isChecked);
  };


  return (
    <BorderFrame showBorder={showBorder}>
    <Box
      // size="xl"
      style={{
      
        backgroundColor: theme.colors.gray[0],
      }}
    >
      <Grid gutter={0} style={{ height: '100%' }}>
        {/* Left 43% component */}
        <Grid.Col span={12} sm={4} sx={{width:"100%"}}> {/* 5/12 ≈ 43% */}
          <Paper
            shadow="sm"
            radius="md"
            style={{
              display: 'flex',
              flexDirection: 'column',
              // justifyContent: 'space-between',
              // padding: theme.spacing.md,
              height: '100%',
            width:"100%",
              backgroundColor: 'white',
            }}
          >
            <Layout title="New Care Plan "               showBorderFunction={handleCheckboxChange}
 data={carePlanSections} />
          </Paper>
        </Grid.Col>

        {/* Right 57% component */}
        <Grid.Col pl={'8px'} span={12} sm={8}> {/* 7/12 ≈ 57% */}
          <Paper
            shadow="sm"
            radius="md"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              // paddingRight: theme.spacing.md,
              // paddingLeft: theme.spacing.md,
              

              height: '100%',
              backgroundColor: 'white',
              overflowY:"auto",
              maxHeight:"90vh",
              scrollBehavior: "smooth",
              "&::-webkit-scrollbar": {
                width: "1px",
              },
              "&::-webkit-scrollbar-thumb": {
                width: "16px",

                backgroundColor: theme.colors.gray[0],
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                width: "16px",

                backgroundColor: theme.colors.gray[2],
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              

            }}
          >
            <NewCarePlan embed={true} />
          </Paper>
        </Grid.Col>
        {/* <Grid.Col span={12} > */}
        <Box pt={'3px'}  sx={{width:"100%"}}>
       < Footer/>
       </Box>
        {/* </Grid.Col> */}



      </Grid>
    </Box>
    </BorderFrame>
  );
};

export default CarePlanEmbed;
